import JobOfferStandards from './JobOfferStandards'
export default JobOfferStandards
